import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsPrefix", "className", "size", "notFoundContent", "dropdownStyle", "suffixIcon", "getPopupContainer"];

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.find.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-tree-select.
* homepage: https://github.com/react-component/tree-select
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RcTreeSelect, { TreeNode, SHOW_ALL, SHOW_PARENT, SHOW_CHILD } from 'rc-tree-select';
import Icon from '../../wui-icon/src';
import classNames from 'classnames';
import warning from 'warning';
import omit from 'omit.js';
import { WebUI } from "../../wui-core/src/index.js";
var defaultProps = {
  transitionName: 'slide-up',
  choiceTransitionName: 'zoom',
  showSearch: false,
  notFoundContent: "无匹配结果"
};
var propTypes = {
  getPopupContainer: PropTypes.func
};
var TreeSelect = (_dec = WebUI({
  name: "select",
  defaultProps: defaultProps
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TreeSelect, _Component);

  var _super = _createSuper(TreeSelect);

  function TreeSelect(props) {
    var _this;

    _classCallCheck(this, TreeSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "saveTreeSelect", function (node) {
      _this.rcTreeSelect = node;
    });

    _defineProperty(_assertThisInitialized(_this), "getChildren", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          treeData = _this$props.treeData,
          loadData = _this$props.loadData;
      if (loadData) return false; // 如果是动态加载对树选择组件，默认有子组件

      if (children) {
        var res = true;
        React.Children.forEach(children, function (child) {
          if (child.props.children && child.props.children.length) {
            res = false;
          }
        });
        return res;
      }

      if (treeData && treeData.length) {
        return !treeData.find(function (data) {
          return data.children && data.children.length;
        });
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "getDropdownClassName", function () {
      var isNoChildren = _this.getChildren();

      var dropdownClassName = _this.props.dropdownClassName;
      var treeSelectPrefixCls = 'tree-select';
      return classNames(dropdownClassName, "".concat(treeSelectPrefixCls, "-dropdown"), "".concat(isNoChildren ? 'no-padding-left' : ''));
    });

    warning(props.multiple !== false || !props.treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
    return _this;
  }

  _createClass(TreeSelect, [{
    key: "focus",
    value: function focus() {
      this.rcTreeSelect.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcTreeSelect.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          clsPrefix = _this$props2.clsPrefix,
          className = _this$props2.className,
          size = _this$props2.size,
          notFoundContent = _this$props2.notFoundContent,
          dropdownStyle = _this$props2.dropdownStyle,
          suffixIcon = _this$props2.suffixIcon,
          getPopupContainer = _this$props2.getPopupContainer,
          restProps = _objectWithoutProperties(_this$props2, _excluded);

      var rest = omit(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
      var cls = classNames('u-tree-select', (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(clsPrefix, "-sm"), size === 'small'), _classNames), className); // showSearch: single - false, multiple - true

      var showSearch = restProps.showSearch;

      if (!('showSearch' in restProps)) {
        showSearch = !!(restProps.multiple || restProps.treeCheckable);
      }

      var checkable = rest.treeCheckable;

      if (checkable) {
        checkable = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-tree-checkbox-inner")
        });
      }

      var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon) : suffixIcon) || /*#__PURE__*/React.createElement(Icon, {
        type: "uf-treearrow-down",
        className: "".concat(clsPrefix, "-arrow-icon")
      });
      var removeIcon = /*#__PURE__*/React.createElement(Icon, {
        type: "uf-close",
        className: "".concat(clsPrefix, "-remove-icon")
      });
      var clearIcon = /*#__PURE__*/React.createElement(Icon, {
        type: "uf-close-c",
        className: "".concat(clsPrefix, "-clear-icon")
      });
      return /*#__PURE__*/React.createElement(RcTreeSelect // switcherIcon={(nodeProps) =>
      //     this.renderSwitcherIcon(clsPrefix, nodeProps)
      // }
      , _extends({
        inputIcon: inputIcon,
        removeIcon: removeIcon,
        clearIcon: clearIcon
      }, restProps, {
        showSearch: showSearch,
        getPopupContainer: getPopupContainer,
        dropdownClassName: this.getDropdownClassName(),
        prefixCls: clsPrefix,
        className: cls,
        dropdownStyle: _objectSpread({
          maxHeight: '100vh',
          overflow: 'auto'
        }, dropdownStyle),
        notFoundContent: notFoundContent,
        treeCheckable: checkable,
        ref: this.saveTreeSelect,
        searchPlaceholder: "\u8BF7\u641C\u7D22"
      }));
    }
  }]);

  return TreeSelect;
}(Component), _defineProperty(_class2, "TreeNode", TreeNode), _defineProperty(_class2, "SHOW_ALL", SHOW_ALL), _defineProperty(_class2, "SHOW_PARENT", SHOW_PARENT), _defineProperty(_class2, "SHOW_CHILD", SHOW_CHILD), _temp)) || _class);
;
TreeSelect.propTypes = propTypes;
export default TreeSelect;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-treeselect/src/TreeSelect.js